export default __webpack_public_path__ + "static/media/020-mini van.5fcc50f7.svg";